export const EVENTS_NEWS_REQUEST = "EVENTS_NEWS_REQUEST";
export const EVENTS_NEWS_SUCCESS = "EVENTS_NEWS_SUCCESS";
export const EVENTS_NEWS_FAIL = "EVENTS_NEWS_FAIL";

export const CREATE_EVENTS_NEWS_REQUEST = "CREATE_EVENTS_NEWS_REQUEST";
export const CREATE_EVENTS_NEWS_SUCCESS = "CREATE_EVENTS_NEWS_SUCCESS";
export const CREATE_EVENTS_NEWS_FAIL = "CREATE_EVENTS_NEWS_FAIL";

export const UPDATE_EVENTS_NEWS_REQUEST = "UPDATE_EVENTS_NEWS_REQUEST";
export const UPDATE_EVENTS_NEWS_SUCCESS = "UPDATE_EVENTS_NEWS_SUCCESS";
export const UPDATE_EVENTS_NEWS_FAIL = "UPDATE_EVENTS_NEWS_FAIL";

export const DELETE_EVENTS_NEWS_REQUEST = "DELETE_EVENTS_NEWS_REQUEST";
export const DELETE_EVENTS_NEWS_SUCCESS = "DELETE_EVENTS_NEWS_SUCCESS";
export const DELETE_EVENTS_NEWS_FAIL = "DELETE_EVENTS_NEWS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 
